(() => {
    const popup = document.querySelector('[data-product-size-guide-popup]');

    if (!popup) {
        return;
    }

    const body = document.body;
    const closeButton = popup.querySelector('[data-close-product-size-guide]');
    const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    let activeTrigger = null;

    const isOpen = () => popup.classList.contains('is-show');

    const openPopup = (trigger) => {
        activeTrigger = trigger;
        body.classList.add('product-size-guide-show');
        popup.classList.add('is-show');
        popup.setAttribute('aria-hidden', 'false');
        closeButton?.focus();
    };

    const closePopup = () => {
        if (!isOpen()) {
            return;
        }

        body.classList.remove('product-size-guide-show');
        popup.classList.remove('is-show');
        popup.setAttribute('aria-hidden', 'true');
        activeTrigger?.focus();
        activeTrigger = null;
    };

    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-open-product-size-guide]');

        if (trigger) {
            event.preventDefault();
            openPopup(trigger);
            return;
        }

        if (event.target.closest('[data-close-product-size-guide]')) {
            event.preventDefault();
            closePopup();
            return;
        }

        if (isOpen() && !popup.contains(event.target)) {
            closePopup();
        }
    });

    document.addEventListener('keydown', (event) => {
        if (!isOpen()) {
            return;
        }

        if (event.key === 'Escape') {
            event.preventDefault();
            closePopup();
            return;
        }

        if (event.key !== 'Tab') {
            return;
        }

        const focusableElements = Array.from(popup.querySelectorAll(focusableSelector));

        if (focusableElements.length === 0) {
            event.preventDefault();
            return;
        }

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
        }
    });
})();
